import { getSummary } from '@/actions/hotels/aiSummary';
import { faSparkles } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import sparkle from "@/utils/loading/sparkles-animations.json";
import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
import Image from 'next/image';

export default function AiHotelSummary({ hotelId }: { hotelId: string }) {
    const [isLoading, setIsLoading] = useState(false);
    const [text, setText] = useState('')

    async function handleGetSummary() {
        setIsLoading(true)
        const res = await getSummary(hotelId)
        const { result, response } = JSON.parse(res)

        if (response.ok) {
            setText(result.description)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        handleGetSummary()
    }, [])
    return (
        isLoading ? <div className='  flex gap-2 items-center justify-center'>
            <span className='text-secondary-500 text-xl font-bold bg-clip-text mb-3 animate-pulse'>Atlas</span>
            <Lottie
                className="max-w-4 h-4"
                animationData={sparkle}
                loop={true}
            />
        </div> : text && <div className='bg-secondary-50 p-4 rounded-2xl '>
            <p className='flex items-center gap-4'>
                <Image
                    className='size-8'
                    src={`${process.env.NEXT_PUBLIC_STORAGE_URL}avatar/f567d7dc-381b-4f86-986c-ba04fb62d3a4-planingo.png`}
                    alt="AI-Generated Summary"
                    width={48}
                    height={48}
                />
                <span className='text-secondary-500 bg-clip-text font-semibold'>AI-Generated Summary</span></p>
            <p className='text-xs md:text-sm font-normal mt-2' >
                {text}
            </p>
        </div>
    );
}